// @flow

export type NormalizedCollectionPath = Array<
  string | number | Object | Array<*>,
>
export type CollectionPath = string | number | NormalizedCollectionPath

const states: {
  [string]: (string, string, NormalizedCollectionPath) => [string, string],
} = {
  INIT: (curr, v, ctx) => {
    if (v === '[') {
      if (curr.length) ctx.push(curr)
      return ['NUM', '']
    }
    if (v === '.') {
      ctx.push(curr)
      return ['INIT', '']
    }
    if (v === '\\') return ['ESC', curr]
    return ['INIT', curr + v]
  },
  ESC: (curr, v) => ['INIT', curr + v],
  NUM: (curr, v, ctx) => {
    if (/[0-9]/.test(v)) curr += v
    else if (v === ']') {
      ctx.push(curr.length ? Number(curr) : '[]')
      return ['NUM_END', '']
    } else return ['NOT_NUM', `[${curr + v}`]
    return ['NUM', curr]
  },
  NOT_NUM: (curr, v, ctx) => {
    if (v === ']') {
      ctx.push(curr + v)
      return ['INIT', '']
    }
    return ['NOT_NUM', curr + v]
  },
  NUM_END: (curr, v, ctx) =>
    v === '.' ? ['INIT', curr] : states.INIT(curr, v, ctx),
}

export const parseStringPath = (p: string) => {
  if (p === '') return ['']
  const r = []
  let state = ['INIT', '']
  for (let i = 0; i < p.length; i++) {
    state = states[state[0]](state[1], p[i], r)
  }
  if (state[1]) r.push(state[1])
  return r
}

export const parse = (p: string | number): NormalizedCollectionPath =>
  typeof p === 'string' ? parseStringPath(p) : [p]

export const normalize = (path: CollectionPath): NormalizedCollectionPath =>
  Array.isArray(path) ? path : parse(path)

const pathToString = (path: NormalizedCollectionPath) =>
  path
    .map((v, k) =>
      typeof v === 'number'
        ? `[${v}]`
        : `${k === 0 ? '' : '.'}${
            typeof v === 'string' ? v.replace('.', '\\.') : v.toString()
          }`,
    )
    .join('')

export const stringify = (path: CollectionPath) =>
  Array.isArray(path) && path.length === 0
    ? undefined
    : pathToString(((path: any): NormalizedCollectionPath))

export default {
  normalize,
  parse,
  stringify,
}
